import GeneralTab from 'components/desktop/ShoppingCart/Search/tabs/GeneralTab';
import STATUS from 'types/ShoppingCart/Status';

const ReviewTab = () => {
	return <GeneralTab status={STATUS.REVIEW} />;
};

export default ReviewTab;
